import { render } from "./expertLevelModal.vue?vue&type=template&id=46d50264&ts=true"
import script from "./expertLevelModal.vue?vue&type=script&lang=ts"
export * from "./expertLevelModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__